export const InputIcons = {
  ReadOnlyIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      height="16"
      width="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.444 5.778h-1.777v-1.26a2.45 2.45 0 00-.781-1.78A2.748 2.748 0 008 2c-.707 0-1.386.265-1.886.738a2.45 2.45 0 00-.78 1.78v1.26H3.555a.916.916 0 00-.629.246.817.817 0 00-.26.593v5.877c0 .223.093.436.26.593a.916.916 0 00.629.246h8.888a.916.916 0 00.629-.246.816.816 0 00.26-.593V6.617a.817.817 0 00-.26-.593.916.916 0 00-.629-.246zM8 10.185a.695.695 0 01-.37-.106.64.64 0 01-.246-.283.597.597 0 01-.038-.363.62.62 0 01.183-.323.703.703 0 01.727-.136.66.66 0 01.298.232.605.605 0 01-.083.795.687.687 0 01-.471.184zm1.778-4.407H6.222v-1.26c0-.445.188-.872.52-1.187A1.832 1.832 0 018 2.84c.472 0 .924.176 1.257.491.333.315.52.742.52 1.188v1.259z"
        fill="var(--text-tetriary-transparent)"
      />
    </svg>
  ),
  ErrorIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      height="24"
      width="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm-.692 4.846a.692.692 0 111.384 0v4.846a.692.692 0 11-1.384 0V7.846zm.692 9a1.038 1.038 0 110-2.076 1.038 1.038 0 010 2.076z"
        fill="currentColor"
      />
    </svg>
  ),
  WarningIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      height="24"
      width="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.743 17.127l-7.027-12.15A1.985 1.985 0 0012 4a1.996 1.996 0 00-1.715.978l-7.027 12.15a1.875 1.875 0 000 1.897A1.952 1.952 0 004.974 20h14.053a1.964 1.964 0 001.714-.975 1.875 1.875 0 00.002-1.898zM11.358 10.4A.639.639 0 0112 9.76a.644.644 0 01.643.64v3.2a.638.638 0 01-.643.64.644.644 0 01-.642-.64v-3.2zM12 17.44a.967.967 0 01-.89-.593.956.956 0 01.702-1.309.968.968 0 01.99.409.957.957 0 01-.12 1.212.966.966 0 01-.682.28z"
        fill="currentColor"
      />
    </svg>
  ),
  SuccessIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      height="24"
      width="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm3.951 7.413l-4.846 4.846a.692.692 0 01-.98 0L8.05 13.182a.693.693 0 11.98-.98l1.586 1.588 4.357-4.357a.693.693 0 01.98.98z"
        fill="currentColor"
      />
    </svg>
  ),
  ResetIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      height="24"
      width="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm3.259 11.28a.691.691 0 11-.98.979L12 12.979l-2.28 2.28a.691.691 0 01-1.182-.49.693.693 0 01.203-.49L11.021 12l-2.28-2.28a.693.693 0 01.98-.979L12 11.021l2.28-2.28a.692.692 0 11.979.98L12.979 12l2.28 2.28z"
        fill="var(--text-tetriary-transparent)"
      />
    </svg>
  ),
};
